import { CamelCaseKeys, Numeric } from "@utils/typescript";
import { UserLess } from "./User";

export enum CollaboratableTypes {
  InsurancePolicy = 'InsurancePolicy',
}

export type Collaboration = CamelCaseKeys<{
  id: number;
  brokerage_percentage: Numeric;
  created_at: number;

  collaborator_id: number;
  collaborator: UserLess;
}>;
